/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Entity Id and other details of an entity at that level.
 */
export interface EntityId { 
    /**
     * Description/Name of entity
     */
    id: string;
    /**
     * Type of entity
     */
    type: string;
}

